import React, { Component } from 'react';
import './InspirationBlock.module.scss';
import {inspirationData} from 'utilities/Inspiration';

class InspirationBlock extends Component {

    constructor() {
        super();

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        this.props.handleClick(this.props.index);
    }

    render() {
        
        var { inspiration } = this.props;

        let slug = inspiration.name.split(" ").join("-").toLowerCase();


        return (
            <div styleName='inspiration-block' onClick={this.handleClick}>
                <div styleName='triangle'></div>
                <div styleName='inspiration-image' style={{backgroundImage: `url(${`/images/inspiration/${inspiration.name.split(" ").join("-").toLowerCase() }.jpg`})`}}>
                </div>
                <div styleName='inspiration-content'>
                    <p styleName={'title'}>{inspiration.name}</p>
                    <p>{inspiration.owner}</p>
                </div>
            </div>
        );  
    }
}

export default InspirationBlock;


// WEBPACK FOOTER //
// ./resources/assets/components/UI/InspirationBlock/InspirationBlock.jsx